<template>
  <a-modal
    :visible.sync="isVisible"
    :confirmLoading="loading"
    :maskClosable="false"
    :title="title"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="酒店名称" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input
          placeholder="请输入酒店名称"
          v-decorator="['hotelName', {
            rules: [{ required: true, message: '名称不能为空' },
                    { pattern: /^[\u4E00-\u9FA5\uF900-\uFA2Da-zA-Z0-9]{2,40}$/, message: '输入字符必须是长度2~40的中英文和数字' }],
            validateTrigger: 'blur'
          }]"/>
      </a-form-item>
      <a-form-item label="关联包名" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-select
          mode="multiple"
          placeholder="请选择至少一个APK包名"
          v-decorator="['apk']">
          <a-select-option v-for="item in apk" :key="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="联系方式" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input
          placeholder="请输入联系方式"
          v-decorator="['contact', {
            rules: [{ max: 30, message: '最长不超过30个字符' }]
          }]"/>
      </a-form-item>
      <a-form-item label="地址" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input
          placeholder="请输入厂商所在地址"
          v-decorator="['address', {
            rules: [{ max: 50, message: '地址最长不超过50个字符' }]
          }]"/>
      </a-form-item>
      <a-form-item label="授权数量" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input-number
          :min="1"
          :max="99999999"
          v-decorator="['max', {
            rules: [{ required: true, message: '授权数量限制1-99999999之间' }],
            initialValue: 100
          }]"/>
      </a-form-item>
      <a-form-item label="显示顺序" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input-number
          :min="1"
          :max="999"
          v-decorator="['sort', {
            rules: [{ required: true, message: '显示顺序限制1-999之间' }],
            initialValue: 50
          }]"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { addHotel, updateHotel } from '@/api/vendor'

export default {
  props: {
    visible: {
      required: true,
      type: Boolean
    },

    id: {
      required: false,
      type: String,
      default: ''
    },

    apk: {
      required: false,
      type: Array,
      default () {
        return []
      }
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      title: '新增酒店',
      uuid: ''
    }
  },

  computed: {
    isVisible: {
      get: function () {
        return this.visible
      },
      set: function (val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    load (hotel) {
      if (hotel && hotel.uuid) {
        this.title = '编辑酒店'
        this.uuid = hotel.uuid
        this.$nextTick(() => {
          this.form.setFieldsValue({
            hotelName: hotel.hotelName,
            apk: hotel.apk || [],
            contact: hotel.contact,
            address: hotel.address,
            max: hotel.max,
            sort: hotel.sort
          })
        })
      }
    },

    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          const hotel = JSON.parse(JSON.stringify(values))
          if (this.uuid) {
            hotel.uuid = this.uuid
            updateHotel(hotel).then(response => {
              this.$message.success(response.msg)
              this.$emit('ok', hotel)
              this.handleCancel()
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          } else {
            addHotel(this.id, values).then(response => {
              this.$message.success(response.msg)
              this.$emit('ok', response.data)
              this.handleCancel()
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          }
        } else {
          this.loading = false
        }
      })
    },

    handleCancel () {
      this.uuid = ''
      this.isVisible = false
      this.form.resetFields()
    }
  }
}
</script>

<style scoped>

</style>
